import axiosInstance from './axios-instance';

export const createReservation = (locationId: string, payload: unknown) =>
  axiosInstance.post('reservation/create-reservation', payload, { params: { locationId }});
